/**
 * CampData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { CampInfo } from './camp_info'
import type { UserData } from './user_data'

/**
 * CampData
 */
export interface CampData {
  /** 大本营ID */
  id?: string
  /** 大本营基础信息 */
  info?: CampInfo
  /** 群主信息 */
  owner?: UserData
}

/**
 * CampData Schema
 */
export const CampDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '大本营ID',
      format: 'string',
      type: 'string',
      label: '大本营ID',
    },
    info: {
      $ref: 'CampInfo',
      description: '大本营基础信息',
      label: '大本营基础信息',
    },
    owner: {
      $ref: 'UserData',
      description: '群主信息',
      label: '群主信息',
    },
  },
  type: 'object',
}
